import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import {
  ACTIVE,
  DEACTIVE,
  ROLE,
  SWAL_SETTINGS,
  showFilterlist,
} from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,
  extractTime,
  formateDate,
  formateDateWithMonth,
  formatetime,
  globalLoader,
  handleServerValidations,
  removeSpecialCharacter,
  TrimText,
} from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
// import * as doctorService from "../../../center/services/doctor.services.js";
import { List, Status, Delete } from "../../services/doctor.services";
import { GetAllCenters } from "../../services/usermgmt.services";
import CenterFilter from "../../common/centerFilter";
import { appointmentCancel, listAppointments } from "../../../doctor/services/patient.services";

const AppointmentTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [featuredStatsupdate, setFeaturedStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({column: "appointment_date", order: -1});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    { title: 'Appointments', url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);
  const [centers, setCenters] = useState([]);

  useEffect(() => {
    GetAllCenters()
      .then((data) => {
        setCenters(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
  }, []);


  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        listAppointments(formData, ROLE.SUPER_ADMIN)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list ? data.data.list : []);
            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData)
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);


  const viewfunction = (row) => {
    navigate(
      `/admin/appointment/view/${row._id}`
    );
  };


  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultcenter")[0].selectedIndex = 0;
  };


  const goToEdit = (row) => {
    navigate(
      `/admin/appointment/${params.pgno}/edit/${row._id}`
    );
  };

  const cancelAppointment = (id) => {
    const formData = new FormData();
    formData.append("appointment_id", id);
    formData.append("status", 'canceled');
    Swal.fire({
      customClass: "swal-wide",
      title: t("admin.cafes.msg_are_you_sure"),
      text: t("Do you really want to cancel the appointment."),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("admin.cafes.btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("admin.cafes.btn_yes"),
    }).then((result) => {
      if (result.isConfirmed) {
        appointmentCancel(formData, ROLE.SUPER_ADMIN)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                Appointments
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("admin.filter_placeholder.input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("appointment_date", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <CenterFilter
                    data={centers}
                    prepareSearch={prepareSearch}
                  />
                </div>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("admin.filter_placeholder.btn_reset_filter")}
                </button>
                <button
                  className="btn ripple btn-main-primary signbtn mr-2"
                  onClick={() =>
                    navigate(`/admin/appointment/add`)
                  }
                >
                  {t("admin.cafes.btn_add_new")}
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th>
                      <div className="sorting_column">
                        <span>Appointment ID</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Doctor Name</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Center Name</span>
                      </div>
                    </th>
                    <th>Patient ID</th>
                    <th>Patient Name</th>
                    <th>Appointment Date</th>
                    <th>Appointment Time</th>
                    <th>Status</th>
                    <th className="action_head">{t("admin.list_heading.list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={12}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            // <tr
                            //   key={i}
                            // >
                            //   <td>{row?.appointment_register_id ?  '#'+(row?.appointment_register_id) : 'N/A'}</td>
                            //   <td>
                            //     {row?.doctor_name ? (
                            //       <div className="d-flex">
                            //         {row?.doctor_name ? ((row.doctor_name)) : "N/A"}
                            //       </div>
                            //     ) : (
                            //       <div className="d-flex">N/A</div>
                            //     )}
                            //   </td>
                            //   <td>{row?.center_name ? ((row.center_name)) : "N/A"}</td>
                            //   <td>{row?.patient_register_id ? '#'+(row?.patient_register_id) : 'N/A'}</td>
                            //   <td>{row?.patient_name ? ((row.patient_name)) : "N/A"}</td>
                            //   <td>{row?.appointment_date ? formateDate(row.appointment_date) : "N/A"}</td>
                            //   <td>{row?.start_time ? (row.start_time) : "N/A"}</td>
                            //   <td>{(row?.status)}</td>
                            //   <td>
                            //     <div className="d-flex">
                            //       <button
                            //         className="btn ripple btn-main-primary signbtn"
                            //         onClick={() => {
                            //           viewfunction(row);
                            //         }}
                            //       >
                            //         {t("admin.button.btn_view")}
                            //       </button>

                            //       <button
                            //         className="btn ripple btn-success mlAction"
                            //         onClick={() => {
                            //           goToEdit(row);
                            //         }}
                            //       >
                            //         {t("admin.button.btn_edit")}
                            //       </button>
                            //       {row?.status !== 'canceled' ?
                            //       <button
                            //         className="btn ripple btn-danger mlAction"
                            //       onClick={() => {
                            //         cancelAppointment(row?._id);
                            //       }}
                            //       >
                            //         {t("Cancel")}
                            //       </button>
                            //       :null}
                            //     </div>
                            //   </td>
                            // </tr>
                            <tr key={i}>
                              <td>{typeof row?.appointment_register_id === 'string' && row.appointment_register_id.trim() ? '#' + row.appointment_register_id : '-'}</td>

                              <td>
                                <div className="d-flex">
                                  {typeof row?.doctor_name === 'string' && row.doctor_name.trim()
                                    ? capitalizeFirstLetter(TrimText(row.doctor_name, 30))
                                    : '-'}
                                </div>
                              </td>
                              <td>
                                {typeof row?.center_name === 'string' && row.center_name.trim()
                                  ? capitalizeFirstLetter(TrimText(row.center_name, 30))
                                  : '-'}
                              </td>

                              <td>{typeof row?.patient_register_id === 'string' && row.patient_register_id.trim() ? '#' + row.patient_register_id : '-'}</td>

                              <td>
                                {typeof row?.patient_name === 'string' && row.patient_name.trim()
                                  ? capitalizeFirstLetter(TrimText(row.patient_name, 30))
                                  : '-'}
                              </td>

                              <td>
                                {typeof row?.appointment_date === 'string' && row.appointment_date.trim()
                                  ? formateDate(row.appointment_date)
                                  : '-'}
                              </td>

                              {/* <td>
                                {typeof row?.start_time === 'string' && row.start_time.trim()
                                  ? row.start_time
                                  : '-'}
                              </td> */}
                              <td>
                                {typeof row?.appointment_date === 'string' && row.start_time.trim()
                                  ? extractTime(row.appointment_date)
                                  : '-'}
                              </td>

                              <td>
                                {typeof row?.status === 'string' && row.status.trim()
                                  ? capitalizeFirstLetter(row.status)
                                  : '-'}
                              </td>

                              <td>
                                <div className="d-flex">
                                  <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => viewfunction(row)}
                                  >
                                    {t("admin.button.btn_view")}
                                  </button>

                                  <button
                                    className="btn ripple btn-success mlAction"
                                    onClick={() => goToEdit(row)}
                                  >
                                    {t("admin.button.btn_edit")}
                                  </button>

                                  {row?.status !== 'canceled' && (
                                    <button
                                      className="btn ripple btn-danger mlAction"
                                      onClick={() => cancelAppointment(row?._id)}
                                    >
                                      {t("Cancel")}
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={12} className="text-center">
                            {t("admin.message.msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className=""
              id="example1_info"
              role="status"
              aria-live="polite"
            >
              <b>
                {t("admin.message.msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Appointments",
                    path: "/admin/appointment/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

    </>
  );
};

export default AppointmentTable;
